var _defs, _g, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermPurpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#05f;}.c{fill:#04c;}.d{fill:#fff;}.e{fill:#ff6b00;}.f{opacity:.2;}.g{opacity:.8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 183.52,
    y: 223.41,
    width: 106.37,
    height: 79.78,
    rx: 6.65,
    ry: 6.65
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 293.21,
    cy: 286.57,
    r: 56.51
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M230.06,304.32h-46.54c-12.83,0-23.27-10.44-23.27-23.27v-104.18c0-1.84,1.49-3.32,3.32-3.32h58.58c4.97,0,9.64,2.2,12.82,6.04l12.4,15.01h75.76c1.84,0,3.32,1.49,3.32,3.32v22.17c0,1.84-1.49,3.32-3.32,3.32s-3.32-1.49-3.32-3.32v-18.84h-74c-.99,0-1.93-.44-2.56-1.21l-13.4-16.22c-1.9-2.3-4.71-3.62-7.69-3.62h-55.25v100.85c0,9.17,7.46,16.62,16.62,16.62h46.54c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M213.43,199.03h-28.81c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h28.81c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M250,426.18c-.57,0-1.15-.15-1.66-.45l-149.7-86.43c-1.03-.59-1.66-1.69-1.66-2.88V163.57c0-1.19,.63-2.29,1.66-2.88L248.34,74.27c1.03-.6,2.3-.6,3.32,0l149.7,86.43c1.03,.59,1.66,1.69,1.66,2.88v172.85c0,1.19-.63,2.29-1.66,2.88l-149.7,86.43c-.51,.3-1.09,.45-1.66,.45Zm-146.37-91.67l146.37,84.51,146.37-84.51V165.5L250,80.98,103.63,165.5v169.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M289.99,329.75c-1.48,0-2.96-.06-4.45-.19-12.43-.98-24.22-6.4-33.18-15.24-8.9-8.86-14.39-20.6-15.47-33.06-1.08-12.45,2.3-24.98,9.52-35.25,7.23-10.27,17.89-17.71,30.02-20.96,12.15-3.23,25.09-2.1,36.45,3.19,1.67,.78,2.38,2.75,1.61,4.42-.78,1.67-2.75,2.4-4.42,1.6-9.95-4.65-21.28-5.64-31.92-2.79-10.63,2.84-19.97,9.36-26.3,18.36-6.32,9-9.28,19.96-8.34,30.86,.95,10.89,5.76,21.17,13.54,28.91,7.83,7.73,18.15,12.47,29.04,13.34,10.9,.95,21.89-2.07,30.95-8.45,8.97-6.31,15.47-15.66,18.28-26.32,2.26-8.54,2.04-17.49-.63-25.87-.56-1.75,.41-3.62,2.16-4.17,1.73-.55,3.62,.41,4.17,2.16,3.05,9.58,3.29,19.81,.72,29.58-3.21,12.17-10.63,22.85-20.89,30.06-9.11,6.4-19.93,9.82-30.87,9.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M289.93,238.39c-1.84,0-3.32-1.49-3.32-3.32v-16.63c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v16.63c0,1.84-1.49,3.32-3.32,3.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M289.93,338.15c-1.84,0-3.32-1.49-3.32-3.32v-16.62c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v16.62c0,1.84-1.49,3.32-3.32,3.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.15,279.98h-16.63c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h16.63c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M248.36,279.98h-16.63c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h16.63c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M289.89,302.08c-14.05,0-25.49-11.43-25.49-25.49s11.43-25.48,25.49-25.48,25.49,11.43,25.49,25.48-11.43,25.49-25.49,25.49Zm0-44.32c-10.39,0-18.84,8.45-18.84,18.83s8.45,18.84,18.84,18.84,18.84-8.45,18.84-18.84-8.45-18.83-18.84-18.83Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermPurpose);
export default __webpack_public_path__ + "static/media/term_purpose.2b81b3ee094b6318ca02118d1b3f4924.svg";
export { ForwardRef as ReactComponent };